import { QuickSearch } from 'app/types/search';

export interface Address {
  Street: string;
  City: string;
  Country: string;
  CountryId?: number;
  Zip: boolean;
  Text?: string;
}

export interface AreaOption extends QuickSearch {
  key: string;
  // Geoapify bounds of the area, sent back with the street search.
  filter?: string;
}

export interface StreetOption extends QuickSearch {
  key: string;
  area?: string;
  placeId?: string;
}

export const toAreaOptions = (areas: any[]): AreaOption[] =>
  areas.map((area, index) => ({
    key: area.PlaceId ?? `${area.Name}-${index}`,
    label: area.Region ? `${area.Name} (${area.Region})` : area.Name,
    value: area.Name,
    filter: area.Filter ?? undefined
  }));

// The API returns one row per street name, so the value is unique and antd resolves a pick by it.
export const toStreetOptions = (streets: any[]): StreetOption[] =>
  streets.map((street, index) => ({
    key: street.PlaceId ?? `${street.Street}-${index}`,
    label: street.Area ? `${street.Street}, ${street.Area}` : street.Street,
    value: street.Street,
    area: street.Area ?? undefined,
    placeId: street.PlaceId ?? undefined
  }));
